export default __webpack_public_path__ + "static/coninpar-58076ac1b085ab49fc80332786c2215b.svg";